<ticker-card
  titleText="Leads"
  total="51"
  [percentage]="8.5"
  tone="info"
  icon="datapie"
></ticker-card>
